import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { get } from 'lodash';
import timelineSharingSelector from '@store/timeline/sharing/selectors';
import * as sharingActions from '@store/timeline/sharing/actions';
import { PAGE_TYPE } from '@utils/constants';
import Timeline from './index';
import sharing from '../common/sharing';
import injectorServer from '../common/injectorServer';

const timelineSharingPageSelector = createSelector(timelineSharingSelector, (store) => ({
  isFetching: get(store, 'isFetching', false),
  isSharing: true,
}));

const TimelineSharing = connect(timelineSharingPageSelector, {
  init: sharingActions.initRequest,
  getSharing: sharingActions.getSharing,
})(sharing()(Timeline));

export default injectorServer({}, { pageType: PAGE_TYPE.SHARING })(TimelineSharing);
